import React from "react";
import styles from "./Navigator.module.css";

const Navigator = () => {
  return (
    <header className={styles.header}>
      <img className={styles.title} src={require('../../images/logo.png')} />
      <span className={styles.subtitle}>Vision Training Device</span>
    </header>
  );
};

export default Navigator;
